import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgxEzModalService } from '../../../../../../shared/modules/ngx-ez-modal/ngx-ez-modal.service';
import { DivisionsService } from "../../../../../../shared/modules/core/services/divisions.service";

@Component({
  selector: 'app-rank-select-modal',
  templateUrl: './rank-select-modal.component.html',
  styleUrls: ['./rank-select-modal.component.scss']
})
export class RankSelectModalComponent {
  @Input() game: string;
  @Input() min: number;
  @Input() max: number;
  @Input() lang: string;
  @Input() state: string = 'current';

  @Output() selected = new EventEmitter<string>();

  @ViewChild('lol', { static: true }) lolTemplate!: TemplateRef<any>;
  @ViewChild('marvel', { static: true }) marvelTemplate!: TemplateRef<any>;

  gamesTemplates: { [key: string]: TemplateRef<any> } = {};

  divisionService: typeof DivisionsService = DivisionsService;
  constructor(public modalService: NgxEzModalService) {
  }

  ngOnInit() {
    this.gamesTemplates = {
      lol: this.lolTemplate,
      marvel: this.marvelTemplate
    };
  }

  public onSelect(rank) {
    this.selected.emit(rank);
    this.modalService.closeOutletModals('public');
  }
}